import React, { useEffect, useState } from 'react';
import { variables } from '../../../../components/variables';
import styled from 'styled-components';

const ItemMenuStyles = styled.a<Partial<ItemMenuProps>>`
    &&& {
        display: block;
        font-size: 12px;
        color: ${(props: Partial<ItemMenuProps>) => props.color || variables.colors['road-grey-090']};
        cursor: ${(props: Partial<ItemMenuProps>) => (props.active ? 'default' : 'pointer')};
        padding: 4px 30px !important;
        background-color: ${(props: Partial<ItemMenuProps>) =>
            props.active ? variables.colors['road-grey-030'] : 'inherit'};
        text-decoration: ${(props: Partial<ItemMenuProps>) => props.textDecoration || 'none'};

        &:hover {
            text-decoration: ${(props: Partial<ItemMenuProps>) => props.textDecoration || 'none'};
            color: ${(props: Partial<ItemMenuProps>) => props.color || variables.colors['road-grey-090']};
            background-color: ${variables.colors['road-grey-030']};
        }
    }
`;

type ItemMenuProps = {
    children: React.ReactNode;
    route: string;
    active?: boolean;
    onClick?: (item: any) => void;
    color?: string;
    textDecoration?: string;
};

/**
 * Item menu component
 */
export const ItemMenu = (props: ItemMenuProps) => {
    return (
        <ItemMenuStyles href={'#' + props.route} className="itemMenu" onClick={props.onClick}>
            {props.children}
        </ItemMenuStyles>
    );
};

/**
 *  Menu
 */

const MenuStyles = styled.div<Partial<MenuProps>>`
    &&& {
        display: block;
        padding: 0 !important;
        margin: -9px 0 !important;
    }
`;

type MenuProps = {
    data: any;
};
export const Menu: React.FC<MenuProps> = ({ data }) => {
    const [currentRoute, setCurrentRoute] = useState(window.location.hash.replace('#', ''));

    useEffect(() => {
        window.onhashchange = () => {
            setCurrentRoute(window.location.hash.replace('#', ''));
        };
    }, [currentRoute]);

    return (
        <MenuStyles>
            {data.navigation.map((menu: any) => (
                <ItemMenu key={menu.route} route={menu.route} active={currentRoute === menu.route}>
                    {menu.name}
                </ItemMenu>
            ))}
        </MenuStyles>
    );
};
